import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookmarkCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBookmarkCheck"><Path fillRule="evenodd" clipRule="evenodd" d="M4 22.2704V2H20V22.2704L12 17.8566L4 22.2704ZM15.9107 8.15L14.85 7.08934L11 10.9393L9.35 9.28934L8.28934 10.35L11 13.0607L15.9107 8.15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBookmarkCheck;
